import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteArticleBannerComponent } from './website-article-banner.component'
import { SharedModule } from '../shared/shared.module'



@NgModule({
  declarations: [WebsiteArticleBannerComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [WebsiteArticleBannerComponent]
})
export class WebsiteArticleBannerModule { }
